var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Underline = function Underline(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 30 30' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M10 23h11v-2H10v2zm5.5-3.8c2.6 0 4.5-2.1 4.5-4.8V9c0-.6-.4-1-1-1s-1 .4-1 1v5.4c0 1.4-.9 2.8-2.5 2.8S13 15.8 13 14.4V9c0-.6-.4-1-1-1s-1 .4-1 1v5.4c0 2.8 1.9 4.8 4.5 4.8z'
      })
    )
  );
};
/*eslint-enable */

export default Underline;
//# sourceMappingURL=Underline.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Underline.js